namespace TabAurous.Finance {
    export interface PaymentDetailsRow {
        TransDetailId?: number;
        TransId?: number;
        LedgerId?: number;
        PartyType?: string;
        LedgerName?: string;
        Amount?: number;
        ExchangeRate?: number;
        RefNo?: string;
        ChequeNo?: string;
        ChequeDate?: string;
        Mode?: string;
        TaxId?: number;
        TaxName?: string;
        TaxAmount?: number;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        SysDate?: string;
    }

    export namespace PaymentDetailsRow {
        export const idProperty = 'TransDetailId';
        export const localTextPrefix = 'Finance.PaymentDetails';
        export const deletePermission = 'Finance:Payment:Delete';
        export const insertPermission = 'Finance:Payment:Add';
        export const readPermission = '*';
        export const updatePermission = 'Finance:Payment:Edit';

        export declare const enum Fields {
            TransDetailId = "TransDetailId",
            TransId = "TransId",
            LedgerId = "LedgerId",
            PartyType = "PartyType",
            LedgerName = "LedgerName",
            Amount = "Amount",
            ExchangeRate = "ExchangeRate",
            RefNo = "RefNo",
            ChequeNo = "ChequeNo",
            ChequeDate = "ChequeDate",
            Mode = "Mode",
            TaxId = "TaxId",
            TaxName = "TaxName",
            TaxAmount = "TaxAmount",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            SysDate = "SysDate"
        }
    }
}
